import { type PropsWithChildren, useContext } from 'react';

import { MultiMeterBarChartConfigContext } from '../context/MultiMeterBarChartConfigContext.js';
import { MultiMeterBarChartInternalConfig } from '../types/multi-meter-bar-chart-internal.js';
import { MultiMeterBarChartProps } from '../types/multi-meter-bar-chart.js';
import { buildMultiMeterBarChartConfig } from '../utils/build-multi-meter-bar-chart-config.js';
import { deserializeConfig } from '../utils/deserialize-config.js';
import { iterateSlots } from '../utils/iterate-slots.js';

export const useMultiMeterBarChartConfig = (
  props: PropsWithChildren<MultiMeterBarChartProps>,
): MultiMeterBarChartInternalConfig => {
  const configContext = useContext(MultiMeterBarChartConfigContext);
  const isImportedConfig = typeof configContext === 'string';

  const consumerConfig = isImportedConfig
    ? deserializeConfig(configContext)
    : configContext;

  const slots = iterateSlots(props.children);

  return buildMultiMeterBarChartConfig(props, consumerConfig, slots);
};
